import { FC } from "react";
import type { PriceBreakdown } from "src/Modules/Hotels/hooks/usePriceBreakdown";
import TotalAmount from "../TotalAmount/TotalAmount";
import TotalTopCard from "../TotalTopCard/TotalTopCard";

const HotelMoneyBreakdown: FC<{ price: PriceBreakdown; isPaymentStep?: boolean }> = ({ price, isPaymentStep }) => {
  return (
    <div className="bg-background-default flex flex-col gap-3 rounded-xl p-5 shadow-sm">
      <div>
        <TotalTopCard price={price} />
      </div>
      <div className="border-border-subtle w-full border-t border-dashed" />
      <div>
        <TotalAmount price={price} isPaymentStep={isPaymentStep} />
      </div>
    </div>
  );
};

export default HotelMoneyBreakdown;
